import { Expose } from 'class-transformer';

export class UserDetailsResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'email' })
  email: string;
  @Expose({ name: 'full_name' })
  fullName: string;
  @Expose({ name: 'job_title' })
  jobTitle: string;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'role' })
  role: string;
}
